import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import * as UserDataConfig from '../../pages/user-details/config/user-data.config';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { UtilService } from '../../shared';
/** S changes */
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';


import { LifeStyleQuestion, Sections } from 'src/app/pages/medical-underwriting/model/lifestyle.model';
import { Tooltip } from 'src/app/model/tooltip';
import { NgClass } from '@angular/common';



@Component({
    selector: 'app-radio-toggle-button-new',
    templateUrl: './radio-toggle-button-new.component.html',
    styleUrls: ['./radio-toggle-button-new.component.scss'],
    imports: [NgClass]
})
export class RadioToggleButtonNewComponent implements OnInit, OnDestroy {



  @Input() questionId: string;
  @Input() config: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() parentControlName: string;
  @Input() editMode: boolean;
  selectedOptions: LifeStyleQuestion[] = [];
  conditionalQuestionNumber: any[];
  label1test: string;
  label2test: string;
  selectedLbl: string;
  patternErrorMessage: string = '';
  focusOnLblOne: string[];
  focusOnLblTwo: string[];
  switchLblOne: string[];
  switchLblTwo: string[];
  selectedQuestionLabel: string;
  tooltipObj: Tooltip;
  subscription: any;

  @Output() toggleChangeEvt: EventEmitter<any> = new EventEmitter();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  protected userInputDetail = UserDataConfig.ElementsConfig;
  protected healthAndLifestyleConfig = Object.assign({}, this.userInputDetail.healthAndLifestyleConfig);

  private toggleFlag = false;
  public nextSections;

  constructor(private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private fb: UntypedFormBuilder, private utilService: UtilService) {

  }

  ngOnInit() {
    this.initializeToggleBtn();
    this.initializeInfoText();
  }



  setValueForLabelInForm(option: string) {
    if (this.parent.controls[this.parentControlName]) {
      this.parent.controls[this.parentControlName].setValue(option);
    }
    else {
      this.parent.addControl(this.config.id, this.fb.control(null, Validators.required));
      this.parent.controls[this.parentControlName].setValue(option);
    }
  }

  initializeToggleBtn() {
    this.label1test = this.config.responseValue[0] ? this.config.responseValue[0] : "";
    this.label2test = this.config.responseValue[1] ? this.config.responseValue[1] : "";
    let selectedValue = this.config.responseValueByUser ? this.config.responseValueByUser : this.config.defaultResponseValue;
    this.selectedLbl = selectedValue;
    this.setFocus(selectedValue);
    this.setValueForLabelInForm(selectedValue)
    this.selectedQuestionLabel = selectedValue;
  }

  initializeInfoText() {
    this.tooltipObj = new Tooltip(this.config.helpText, '', false);
  }

  setFocus(value: string) {
    if (value === this.label1test) {
      this.focusOnLblOne = ["switch-handle"];
      this.focusOnLblTwo = ["switch-focus"];
      this.switchLblOne = ["on"];
      this.switchLblTwo = ["off"];
    }
    else {
      this.focusOnLblOne = ["switch-focus"];
      this.focusOnLblTwo = ["switch-handle"];
      this.switchLblOne = ["off"];
      this.switchLblTwo = ["on"];
    }

  }



  emitToggleOptions(option: string) {
    if (this.editMode) {
      const payload = {
        value: option,
        screen: 'toggle'
      };
      if (!this.subscription) {
        this.subscription = this.utilService.updateEditForm.subscribe(res => {
          if (res && res.screen === 'toggle') {
            this.editMode = false;
            this.emitToggleOptions(res.value);
          }
        });
      }
      this.editModelHandler.emit(payload);
    } else {
      this.setFocus(option);
      this.selectedQuestionLabel = option;
      this.setValueForLabelInForm(option);
      this.toggleChangeEvt.emit(option);
    }
  }

  isInvalidPattern = (form): boolean => {
    let inValid = false;
    for (const cont in this.parent.controls) {
      if (this.parent.controls.hasOwnProperty(cont)) {
        const tempQuesObj = this.utilityServiceForMedicalService.getQuestionListForGivenIds([cont], null);
        const range: string = tempQuesObj.length > 0 ? tempQuesObj[0].responseRange : '';
        const tempControl = this.parent.controls[cont];
        if (tempControl.errors && tempControl.errors.pattern) {
          inValid = true;
          this.patternErrorMessage = 'Please enter a value between ' + range.replace('to', 'and');
          break;
        }
      }
    }
    return inValid;
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
